export enum FormItemTypeEnum {
  Phone = 'phone',
  TextArea = 'textarea',
  Counter = 'counter',
  HourPicker = 'hourPicker',
  RadioGroup = 'radioGroup',
  SimpleSelect = 'simpleSelect',
  Password = 'password',
  Text = 'text',
  Number = 'number',
  Hidden = 'hidden',
  WeekPicker = 'weekPicker',
  Uploader = 'uploader',
}
